import {handleGqlResponseBody} from '@/utils/apollo.util';
import {GET_CLIENTS_PAGINATION_QUERY} from '@/graphql/client/client.query';
import {GET_REQUEST_PAGINATED_QUERY} from '@/graphql/request/request.query';

const client = {
	actions: {
		async getClientsPaginatedQuery({commit}, {skip, take, orderBy, query}) {
			return await handleGqlResponseBody(({query: queryMethod}) => {
				return queryMethod({
					query: GET_CLIENTS_PAGINATION_QUERY,
					variables: {
						skip,
						take,
						orderBy,
						query
					},
					fetchPolicy: 'no-cache'
				});
			});
		},
		async getRequestPaginatedQuery({commit}, {skip, take, orderBy, from}) {
			return await handleGqlResponseBody(({query: queryMethod}) => {
				return queryMethod({
					query: GET_REQUEST_PAGINATED_QUERY,
					variables: {
						skip,
						take,
						orderBy,
						from
					},
					fetchPolicy: 'no-cache'
				});
			});
		}
	}
};

export default client;
